import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import LocationPicker from "@/components/common/LocationPicker";
import { UserPlus } from "lucide-react";

export default function Register() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { register } = useApp();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", county: "", city: "" });
  const [loading, setLoading] = useState(false);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast({ title: "Parolă prea scurtă", description: "Minim 6 caractere." });
      return;
    }
    setLoading(true);
    try {
      await register(form);
      toast({ title: "Cont creat!", description: "Bun venit pe amd64.ro" });
      navigate("/", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "A apărut o eroare la înregistrare.";
      toast({ title: "Eroare", description: msg });
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-4 py-10 fade-in">
      <div className="w-full max-w-md amd-card rounded-lg p-6 md:p-8">
        <div className="flex items-center gap-2 mb-1">
          <UserPlus className="w-5 h-5" style={{ color: "var(--amd-primary)" }} />
          <span className="text-xs uppercase tracking-wider font-bold" style={{ color: "var(--amd-primary)" }}>Cont nou</span>
        </div>
        <h1 className="text-2xl font-black text-white">Înregistrare</h1>
        <p className="text-sm mt-1" style={{ color: "var(--amd-text-muted)" }}>Creează un cont în 30 de secunde.</p>

        <Button onClick={googleLogin} className="mt-5 w-full h-11 bg-white text-black hover:bg-neutral-100 font-semibold">
          Continuă cu Google
        </Button>

        <div className="my-5 flex items-center gap-3">
          <div className="h-px flex-1" style={{ background: "var(--amd-border)" }} />
          <span className="text-xs" style={{ color: "var(--amd-text-muted)" }}>SAU CU EMAIL</span>
          <div className="h-px flex-1" style={{ background: "var(--amd-border)" }} />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-white text-xs uppercase tracking-wider">Nume complet</Label>
            <Input value={form.name} onChange={(e) => update("name", e.target.value)} className="amd-input h-11 mt-1.5" required minLength={2} />
          </div>
          <div>
            <Label className="text-white text-xs uppercase tracking-wider">Email</Label>
            <Input type="email" value={form.email} onChange={(e) => update("email", e.target.value)} className="amd-input h-11 mt-1.5" required />
          </div>
          <div>
            <Label className="text-white text-xs uppercase tracking-wider">Parolă (min 6 caractere)</Label>
            <Input type="password" value={form.password} onChange={(e) => update("password", e.target.value)} className="amd-input h-11 mt-1.5" required minLength={6} />
          </div>
          <div>
            <Label className="text-white text-xs uppercase tracking-wider">Telefon</Label>
            <Input value={form.phone} onChange={(e) => update("phone", e.target.value)} className="amd-input h-11 mt-1.5" placeholder="07XX..." />
          </div>
          <div>
            <Label className="text-white text-xs uppercase tracking-wider">Județ & Localitate</Label>
            <div className="mt-1.5">
              <LocationPicker
                county={form.county}
                city={form.city}
                onChange={(county, city) => setForm((f) => ({ ...f, county, city }))}
                testIdPrefix="register"
              />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="amd-btn-primary w-full h-11 font-semibold">
            {loading ? "Se creează contul…" : "Creează cont"}
          </Button>
        </form>

        <p className="mt-5 text-sm text-center" style={{ color: "var(--amd-text-muted)" }}>
          Ai deja cont? <Link to="/login" className="font-semibold amd-link">Conectează-te</Link>
        </p>
      </div>
    </div>
  );
}
